import type { Question } from '../data/act5';

export interface CardButton { label: string; primary?: boolean; onClick: () => void; }

/** Render a card into the overlay root; returns the card element. While a card is up, the body carries `card-open`. */
export function showCard(root: HTMLElement, html: string, buttons: CardButton[] = []): HTMLElement {
  root.innerHTML = '';
  const wrap = document.createElement('div'); wrap.className = 'cardWrap'; root.appendChild(wrap);
  const card = document.createElement('div'); card.className = 'card'; card.innerHTML = html;
  if (buttons.length) {
    const row = document.createElement('div'); row.className = 'row';
    for (const b of buttons) { const el = document.createElement('button'); el.type = 'button'; el.textContent = b.label; if (b.primary) el.className = 'primary'; el.addEventListener('click', b.onClick); row.appendChild(el); }
    card.appendChild(row);
  }
  wrap.appendChild(card);
  document.body.classList.add('card-open');
  const first = card.querySelector<HTMLElement>('button, input'); if (first) first.focus();
  return card;
}

export function clearCard(root: HTMLElement) { root.innerHTML = ''; document.body.classList.remove('card-open'); }

/** Ask the three questions; resolves with the chosen option index per question (-1 if skipped). */
export function askQuestions(root: HTMLElement, title: string, intro: string, questions: Question[], buttonLabel: string): Promise<number[]> {
  return new Promise((resolve) => {
    const fields = questions.map((q, i) => `
      <fieldset><legend>${esc(q.q)}</legend>
        ${q.options.map((o, j) => `<label><input type="radio" name="q${i}" value="${j}">${esc(o)}</label>`).join('')}
      </fieldset>`).join('');
    const card = showCard(root, `<h2>${esc(title)}</h2><p class="sub">${esc(intro)}</p><form id="qf">${fields}</form>`, [
      { label: buttonLabel, primary: true, onClick: () => {
        const answers = questions.map((_, i) => { const el = card.querySelector<HTMLInputElement>(`input[name="q${i}"]:checked`); return el ? Number(el.value) : -1; });
        clearCard(root); resolve(answers);
      } }
    ]);
    card.querySelector('form')!.addEventListener('submit', (e) => e.preventDefault());
  });
}

export function esc(s: string): string { return s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] as string)); }
